import { FunctionComponent } from 'react';

import { Field, Form, FormTheme, RowFields } from '@kanda-libs/ks-component-ts';
import { Button, Loader } from '@kanda-libs/ks-design-library';

import {
  INDEX_FIELD_PROPS,
  INDEX_FIELD_VALIDATION,
  SEARCH_FIELD_PROPS,
  SEARCH_FIELD_VALIDATION,
} from './constants';
import useSearchForm from './useSearchForm';

const SearchForm: FunctionComponent = () => {
  const { form, onSubmit, isSubmitting } = useSearchForm();
  return (
    <FormTheme variant="streamline">
      <Form
        form={form}
        onSubmit={onSubmit}
        id="staff-search-form"
        className="flex flex-col w-full my-auto"
      >
        <div className="flex flex-row gap-4">
          <Field.Validator validation={SEARCH_FIELD_VALIDATION}>
            <Field.Input {...SEARCH_FIELD_PROPS} />
          </Field.Validator>
          <Field.Validator validation={INDEX_FIELD_VALIDATION}>
            <Field.Select {...INDEX_FIELD_PROPS} />
          </Field.Validator>
          <Button.Text
            submit
            id="search-staff-submit"
            label="Search"
            size={40}
            className="mx-auto mt-5"
            disabled={isSubmitting}
          />
        </div>
        <Loader isLoading={isSubmitting} />
      </Form>
    </FormTheme>
  );
};

export default SearchForm;
